import { getToken, getUser } from "../../Utils/Common"
import { getAPICall, postAPICall } from "../axiosMethodCalls"
import Moment from "moment"

export const getSalesOrder = async (info) => {
  try {
    // var cust_name
    // if (info.customer_id_value.label === "All Customers") {
    //   cust_name = ""
    // } else {
    //   cust_name = info.customer_id_value.label
    // }

    const response = await getAPICall(
      process.env.REACT_APP_LINK + "sales_orders/get",
      {
        requester: getUser(),
        token: getToken(),
        sales_order_id: info.id,
        branch_id: info.branch_id,
        customer_id: info.customer_id,
        status: info.status === "all" ? "" : info.status,
        anything: info.anything,
        with_invoice: info.with_invoice,
        date_from: info.date_from
          ? Moment(info.date_from).format("YYYY-MM-DD")
          : info.date_from,
        date_to: info.date_to
          ? Moment(info.date_to).format("YYYY-MM-DD")
          : info.date_to,
        page: info.page,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

//POST
export const createSalesOrder = async (data, items) => {
  let form_data = new FormData()
  data.attachments.map((file) => {
    form_data.append(`attachments[]`, file, file.name)
  })
  form_data.append("requester", getUser())
  form_data.append("token", getToken())
  form_data.append("customer_id", data.customer_id)
  form_data.append("branch_id", data.branch_id)
  form_data.append(
    "sales_quotation_id",
    data.sales_quotation_id ? data.sales_quotation_id : ""
  )
  form_data.append("sales_date", data.sales_date)
  form_data.append("delivery_date", data.delivery_date)
  form_data.append("delivery_fee", data.delivery_fee ? data.delivery_fee : 0)
  form_data.append("service_fee", data.service_fee)
  form_data.append(
    "acknowledged_by",
    data.acknowledged_by ? data.acknowledged_by : ""
  )
  form_data.append("ship_via", data.ship_via)
  form_data.append("contact_no", data.contact_no)
  form_data.append("address", data.address)
  form_data.append("remarks", data.remarks || "")
  form_data.append("subtotal", data.subtotal)
  console.log(data.customer_po_no)
  form_data.append("customer_po_no", data.customer_po_no)
  form_data.append("grand_total", data.grand_total)
  form_data.append("paid_total", data.paid_amount)
  // form_data.append("balance", parseFloat(data.grand_total) - parseFloat(data.paid_amount));
  form_data.append("status", data.status)
  data.invoice_no &&
    form_data.append("invoice_no", data.invoice_no ? data.invoice_no : "")

  // form_data.append("payment_type", data.payment_type ? data.payment_type : "");
  // form_data.append("payment_date", data.payment_date ? data.payment_date : "");
  // form_data.append("from_bank_id", data.from_bank_id ? data.from_bank_id : "");
  // form_data.append("from_bank_name", data.from_bank_name ? data.from_bank_name : "");
  // form_data.append("to_bank_id", data.to_bank_id ? data.to_bank_id : "");
  // form_data.append("to_bank_name", data.to_bank_name ? data.to_bank_name : "");
  // form_data.append("cheque_number", data.cheque_number ? data.cheque_number : "");
  // form_data.append("cheque_date", data.cheque_date ? data.cheque_date : "");
  // form_data.append("reference_number", data.reference_number ? data.reference_number : "");
  // form_data.append("transaction_number", data.transaction_number ? data.transaction_number : "");
  // form_data.append("payment_description", data.payment_description ? data.payment_description : "");
  // form_data.append("invoice_no", data.invoice_no ? data.invoice_no : "");
  // form_data.append("term_day", data.term_day ? data.term_day : "");
  // form_data.append("particulars", data.particulars ? data.particulars : "");
  // form_data.append("payee", data.payee ? data.payee : "");
  // form_data.append("paid_amount", data.paid_amount);
  // form_data.append("withholding_tax_total", data.withholding_tax_total ? data.withholding_tax_total : "");
  // form_data.append("deposit_date", data.deposit_date ? data.deposit_date : "");

  // form_data.append('withholding_percentage', data.withholding_percentage);
  data.withholding_percentage &&
    form_data.append(`withholding_percentage`, data.withholding_percentage)
  form_data.append("vat_type", data.vat_type)
  form_data.append("discount", data.discount ? data.discount : 0)
  form_data.append("discounted_subtotal", data.discounted_subtotal)
  form_data.append("vat", data.vat)
  form_data.append("vatable_sales", data.vatable_sales)
  form_data.append("withholding_tax", data.withholding_tax)
  form_data.append(
    "grandtotal_without_service_fee",
    data.grandtotal_without_service_fee
  )

  items.map((item) => {
    form_data.append(
      `sales_quotation_item_id[]`,
      item.sales_quotation_item_id ? item.sales_quotation_item_id : ""
    )
    form_data.append(`item_id[]`, item.item_id ? item.item_id : "")
    form_data.append(`description[]`, item.description ? item.description : "")
    form_data.append(`item_name[]`, item.item_name ? item.item_name : "")
    form_data.append(
      `item_unit_id[]`,
      item.item_unit_id ? item.item_unit_id : ""
    )
    form_data.append(`unit[]`, item.unit ? item.unit : "")
    form_data.append(`price[]`, item.price ? item.price : "")
    form_data.append(`qty[]`, item.qty ? item.qty : "")
    form_data.append(`qty_received[]`, 0)
    item.discount_amount &&
      form_data.append(`discount_amount[]`, item.discount_amount)
    form_data.append(`discount_percentage[]`, item.discount_percentage)
    item.subtotal && form_data.append(`subamount[]`, item.subtotal)

    form_data.append(`amount[]`, item.amount)
    form_data.append(
      `item_remarks[]`,
      item.item_remarks ? item.item_remarks : ""
    )
  })

  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_orders/create",
      form_data
    )

    console.log(response.data)
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const updateSalesOrder = async (data, items) => {
  console.log(data)
  let form_data = new FormData()
  data.attachments.map((file) => {
    form_data.append("attachments[]", file, file.name)
    form_data.append("attachment_ids[]", null)
  })
  data.prev_files.map((file) => {
    form_data.append("attachment_ids[]", file.id)
  })
  form_data.append("requester", getUser())
  form_data.append("token", getToken())
  form_data.append("sales_order_id", data.id)
  form_data.append("customer_id", data.customer_id)
  form_data.append("branch_id", data.branch_id)
  data.sales_quotation_id &&
    form_data.append(
      "acknowledged_by",
      data.sales_quotation_id ? data.sales_quotation_id : ""
    )
  form_data.append("sales_date", data.sales_date)
  form_data.append("delivery_date", data.delivery_date)
  form_data.append("delivery_fee", data.delivery_fee ? data.delivery_fee : 0)
  form_data.append("service_fee", data.service_fee)
  data.acknowledged_by_value &&
    form_data.append(
      "acknowledged_by",
      data.acknowledged_by_value ? data.acknowledged_by_value.value : ""
    )
  form_data.append("ship_via", data.ship_via)
  form_data.append("contact_no", data.contact_no)
  form_data.append("address", data.address)
  form_data.append("remarks", data.remarks || "")
  form_data.append("subtotal", data.subtotal)
  form_data.append("customer_po_no", data.customer_po_no)
  // form_data.append("sub_total", data.sub_total);
  form_data.append("grand_total", data.grand_total)

  if (data.paid_total) {
    form_data.append("paid_total", data.paid_total)
  }

  // form_data.append("balance", parseFloat(data.grand_total) - parseFloat(data.paid_amount));
  form_data.append("status", data.status)
  data.invoice_no &&
    form_data.append("invoice_no", data.invoice_no ? data.invoice_no : "")

  // form_data.append('withholding_percentage', data.withholding_percentage);
  data.withholding_percentage &&
    form_data.append(`withholding_percentage`, data.withholding_percentage)
  form_data.append("vat_type", data.vat_type)
  form_data.append("discount", data.discount)
  form_data.append("discounted_subtotal", data.discounted_subtotal)
  form_data.append("vat", data.vat)
  form_data.append("vatable_sales", data.vatable_sales)
  form_data.append("withholding_tax", data.withholding_tax)
  form_data.append(
    "grandtotal_without_service_fee",
    data.grandtotal_without_service_fee
  )

  items.map((item) => {
    form_data.append(
      `sales_quotation_item_id[]`,
      item.sales_quotation_item_id ? item.sales_quotation_item_id : ""
    )
    form_data.append(`sales_order_item_id[]`, item.id ? item.id : "")
    form_data.append(`item_id[]`, item.item_id ? item.item_id : "")
    form_data.append(`description[]`, item.description ? item.description : "")
    form_data.append(`item_name[]`, item.item_name ? item.item_name : "")
    form_data.append(
      `item_unit_id[]`,
      item.item_unit_id ? item.item_unit_id : ""
    )
    form_data.append(`unit[]`, item.unit ? item.unit : "")
    form_data.append(`price[]`, item.price ? item.price : "")
    form_data.append(`qty[]`, item.qty ? item.qty : "")
    form_data.append(`qty_received[]`, 0)
    form_data.append(`discount_amount[]`, item.discount_amount)
    form_data.append(`discount_percentage[]`, item.discount_percentage)
    if (item.subtotal) {
      form_data.append(`subamount[]`, item.subtotal)
    }
    form_data.append(`amount[]`, item.amount)
    form_data.append(
      `item_remarks[]`,
      item.item_remarks ? item.item_remarks : ""
    )
  })

  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_orders/update",
      form_data
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const deleteSalesOrder = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_orders/delete",
      {
        requester: getUser(),
        token: getToken(),
        sales_order_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const voidSalesOrder = async (id, reason) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_orders/update_status",
      {
        requester: getUser(),
        token: getToken(),
        sales_order_id: id,
        void_reason: reason,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}
